import { HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';

const httpLink = new HttpLink({
  uri: import.meta.env.PUBLIC_API_URL,
});

export const splitLink = (getToken: () => Promise<string>) => {
  const wsClient = createClient({
    url: import.meta.env.PUBLIC_API_SUBSCRIPTION_URL,
    connectionParams: async () => {
      const token = await getToken();
      return {
        authToken: token,
      };
    },
  });

  const wsLink = new GraphQLWsLink(wsClient);

  return split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    httpLink,
  );
};
